import { queryOptions, useQuery } from "@tanstack/react-query";

import type { QueryConfig } from "@/lib/react-query";
import { apiPaths } from "@/config/paths";
import { authApi } from "@/lib/api-client";
import { env } from "@blueskydataplatform/shared-ui/config/env";
import type { Provider } from "@blueskydataplatform/shared-ui/types/providers.types";

const getProviders = (): Promise<{
  data: Provider[];
}> => {
  return authApi.get(apiPaths.providers.getProviders.getPath(), {
    baseURL: env.AUTH_API_URL,
  });
};
const getProvidersQueryOptions = () => {
  return queryOptions({
    queryKey: ["providers"],
    queryFn: () => getProviders(),
    select: data => data.data,
  });
};

type UseProvidersOptions = {
  queryConfig?: QueryConfig<typeof getProvidersQueryOptions>;
};

export const useProviders = ({ queryConfig }: UseProvidersOptions = {}) => {
  return useQuery({
    ...getProvidersQueryOptions(),
    ...queryConfig,
  });
};
